module.exports = __webpack_public_path__ + "img/t5-img5.eda91406.png";